import React, { useState, useEffect } from 'react'

export default function OrderRevenue({ revenue }) {
    const [countries] = useState(['USA', 'Canada'])
    const [internalReenue, setInternalRevenue] = useState([])

    useEffect(() => {
        setInternalRevenue(Object.values(revenue))
        console.log(revenue)
    }, [revenue])


    return (
        <div className="ibox">
            <div className="ibox-title" style={{ minHeight: 84 }}>
                <h5 className="d-inline">Revenue</h5>
                <div className="ibox-tools">
                    <div className='custom-ibox-tools'>
                        <span className='text-uppercase'>Total Orders</span>
                    </div>
                    {
                        countries.map((country, i) => (
                            <div className='custom-ibox-tools' key={i}>
                                <span>{country}: </span>
                                <span>{internalReenue.length > 1 && internalReenue[i].totalRevenue}</span>
                            </div>
                        ))
                    }
                </div>
            </div>
            <div className="card card-dashboard-table">
                <table className="table table-bordered">
                    <caption className='small'>
                        &nbsp;<small>*Total Revenue = Cust. Price+Service Chgs.+Delivery Chgs+Tips+Taxes-Admin Discount</small><br />
                        &nbsp;<small>1. Currency in USA: USD</small><br />
                        &nbsp;<small>2. Currency in Canada: CAD</small>
                    </caption>
                    <thead>
                        <tr>
                            <th>Country</th>
                            <th className='bg-primary'>CP</th>
                            <th className='bg-warning'>Srvc. Chgs</th>
                            <th className='bg-info'>Delivery</th>
                            <th className='bg-success'>Tips</th>
                            <th className='bg-danger'>Taxes</th>
                            <th className='bg-danger'>ADisc.</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            Array.isArray(internalReenue) && internalReenue.map((rev, index) => (
                                <tr key={index}>
                                    <td ><a href="#" className='small'>{countries[index]}</a></td>
                                    <td className='small'>{rev.mealRevenue}</td>
                                    <td className='small'>{rev.totalServiceFee}</td>
                                    <td className='small'>{rev.totalDelivery}</td>
                                    <td className='small'>{rev.tips}</td>
                                    <td className='small'>{rev.taxes}</td>
                                    <td className='small'>{rev.discount}</td>

                                </tr>
                            )
                            )
                        }

                    </tbody>
                </table>
            </div>
        </div>
    )
}
